import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import TraditionTag from "@/components/TraditionTag";

export default function BookCard({ book, index = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{
        duration: 0.9,
        delay: Math.min(index * 0.07, 0.35),
        ease: [0.22, 1, 0.36, 1],
      }}
    >
      <Link to={`/books/${book.slug}`} className="block group">
        <div className="card-shrine rounded-sm overflow-hidden">
          <div className="relative aspect-[2/3] overflow-hidden bg-parchment-deep">
            <img
              src={book.cover_url}
              alt={book.name}
              loading="lazy"
              className="w-full h-full object-cover transition-transform duration-slower ease-breath group-hover:scale-[1.04]"
            />
            {book.is_pending && (
              <div className="absolute top-3 left-3">
                <span className="tradition-tag bg-cream/90 border-saffron-fire/40 text-saffron-fire">
                  Launching
                </span>
              </div>
            )}
          </div>

          <div className="p-5 md:p-6">
            <TraditionTag tradition={book.tradition} className="mb-3" />
            <h3 className="font-display text-xl md:text-2xl text-ink leading-tight group-hover:text-dharma-gold-deep transition-colors duration-700 ease-breath">
              {book.name}
            </h3>
            {book.anchor?.source && (
              <p className="font-serif italic text-ink-mute text-sm mt-2 leading-snug">
                {book.anchor.source}
              </p>
            )}
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
